import { render, staticRenderFns } from "./YourBusinessNetworkWrapper.vue?vue&type=template&id=5cfac911"
import script from "./YourBusinessNetworkWrapper.vue?vue&type=script&lang=js"
export * from "./YourBusinessNetworkWrapper.vue?vue&type=script&lang=js"
import style0 from "./YourBusinessNetworkWrapper.vue?vue&type=style&index=0&id=5cfac911&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports